// Check campaign name
import imageCfUrl from '@/config/imageCfUrl'

const listHide = [
  'iphone-14',
  'iphone-15',
  'pre-order-iphone-15-series',
]

export const isShowDelivery = campaignSlug => {
  // check contain iPhone 14,iPhone 15
  if (listHide.includes(campaignSlug.toLowerCase())) {
    return false
  }
  // because selected from checkout is delivery or pickup in store
  return false
}

export const resizeImage = (url, width = 1000) => {
  return `${imageCfUrl}width=${width}/${url}`
}
